import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import { DatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';
import React, { FC } from 'react';
import { DATE_INPUT_DISPLAY_FORMAT } from 'api/models';
import { useTranslation } from 'hooks/use-translation';
import { DueDatePickerFooter } from './footer';
import { DateValueType } from './types';

type DueDateSinglePickerProps = Omit<
  DatePickerProps,
  'showToday' | 'bordered' | 'open' | 'placeholder' | 'suffixIcon'
> & {
  canChooseStartDate: boolean;
  useAsStartDatePicker?: boolean;
  hideFooter?: boolean;
  clearDates(): void;
  modifyPickerType(): void;
  pickToday(): void;
  pickTomorrow(): void;
  onDone(): void;
  updateDates(date: DateValueType): void;
};

export const DueDateSinglePicker: FC<DueDateSinglePickerProps> = ({
  canChooseStartDate,
  useAsStartDatePicker,
  hideFooter,
  clearDates,
  modifyPickerType,
  pickToday,
  pickTomorrow,
  updateDates,
  onDone,
  ...rest
}) => {
  const dueDateText = useTranslation('due_date');

  return (
    <DatePicker
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      autoFocus
      bordered={false}
      tabIndex={-1}
      showToday={false}
      open
      format={DATE_INPUT_DISPLAY_FORMAT}
      placeholder={dueDateText}
      suffixIcon={<EventSchedule16 />}
      onChange={updateDates}
      renderExtraFooter={() =>
        !hideFooter ? (
          <DueDatePickerFooter
            canChooseStartDate={canChooseStartDate}
            type="single"
            onPickToday={pickToday}
            onPickTomorrow={pickTomorrow}
            onClear={clearDates}
            modifyPickerType={modifyPickerType}
            onDone={onDone}
            useAsStartDatePicker={useAsStartDatePicker}
          />
        ) : null
      }
    />
  );
};
